import type { ComponentProps } from 'react';

import { Button } from '@opendoor/atoms/button';
import { IconMapPin } from '@tabler/icons-react';
import { homepageSellerAddressFlow } from 'components/api/homepageSellerAddressFlow';

import NewSellerFlowAddressInput from './NewSellerFlowAddressInput';

type CashOfferAddressInputProps = Pick<
  ComponentProps<typeof NewSellerFlowAddressInput>,
  'trackingTaxonomy' | 'originSurface' | 'channel' | 'onAddressEntryInteraction'
> & { analyticsName: string };

export const CashOfferAddressInput = ({
  trackingTaxonomy,
  originSurface,
  channel,
  onAddressEntryInteraction,
  analyticsName,
}: CashOfferAddressInputProps) => {
  const renderActionButton = (onPress: () => void, isLoading?: boolean) => (
    <Button
      aria-label="Get offer"
      analyticsName={analyticsName}
      variant="secondaryInverse"
      size="sm"
      className="h-14 w-full rounded-2xl px-4 sm:h-11 sm:w-26 sm:rounded-xl"
      loading={isLoading}
      onClick={onPress}
    >
      Get offer
    </Button>
  );

  return (
    <NewSellerFlowAddressInput
      hideLabel
      placeholder="Enter your home address"
      trackingTaxonomy={trackingTaxonomy}
      originSurface={originSurface}
      channel={channel}
      onAddressEntryInteraction={onAddressEntryInteraction}
      sellerFlow={homepageSellerAddressFlow}
      trackAddressEntry={false}
      confirmationMode="owner-first"
      leadingIcon={<IconMapPin size={24} aria-hidden />}
      size="sm"
      actionButtonLayout="responsive"
      inputClassName="focus:ring-1 focus:ring-od-content-primary data-popup-open:ring-1 data-popup-open:ring-od-content-primary"
      popupClassName="ring-1 ring-od-content-primary"
      actionButton={renderActionButton}
    />
  );
};
